export function parseNumber(number: string): number | undefined {
  const parsed = Number.parseInt(number);

  return Number.isNaN(parsed) ? undefined : parsed;
}
